export const isBatteryProposalPath = (pathname: string): boolean =>
  pathname === `/battery-proposal` || pathname.startsWith(`/battery-proposal/`)
